import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Partnerlogo } from '@model/partnerlogo';
import { SerializationService } from 'aautil';
import { RestService } from './rest/rest.service';
import { SentryService } from './sentry.service';

@Injectable({
  providedIn: 'root',
})
export class PartnerService {
  constructor(
    private SentryService: SentryService,
    private RestService: RestService,
    private SerializationService: SerializationService,
  ) {}

  public partnerStatements = [
    {
      text: '„Bereits seit vier Jahren in Folge ist SEMA nun schon Kooperationspartner des Zimmerer-Treffpunkts. So fördern wir die Zimmerer-Community im Internet und können zugleich in Socialmedia von unserer Software und tollen Kundenprojekten begeistern.“',
      name: 'Alexander Neuss',
      title: 'Geschäftsführer von Sema',
      img: environment.publicFolder + 'assets/images/partner/compressed/AlexanderNeuss.png',
    },
    {
      text: '„Als Südtiroler Unternehmen, das international tätig ist, gefällt uns besonders, dass beim Zimmerer-Treffpunkt grenzübergreifend die Zimmerer voneinander lernen und fachlich diskutieren können. Wir von Rothoblaas sind Holzbauspezialisten, daher ist der Zimmerer-Treffpunkt die optimale Plattform um unsere Produkte dem Zimmerer zu präsentieren.“',
      name: 'Peter Irschara',
      title: 'Gesamtvertriebsleiter Rothoblaas Deutschland',
      img: environment.publicFolder + 'assets/images/partner/compressed/PeterIrschara.png',
    },
    {
      text: '„Auf der Messe DACH+HOLZ in Stuttgart 2020 arbeiten wir nun das zweite Mal mit dem Zimmerer-Treffpunkt zusammen. Das Team unterstützt uns bei der Berichterstattung in Socialmedia und der Organisation des Nachwuchstages. Man merkt, dass sie wirklich vom Fach und mit Herzblut dabei sind.“',
      name: 'Robert Schuster',
      title: 'Projektleiter DACH+HOLZ International',
      img: environment.publicFolder + 'assets/images/partner/compressed/RobertSchuster.png',
    },
    {
      text: '„Wir sind bereits seit vier Jahren Partner des Zimmerer-Treffpunkts und sehr zufrieden mit der Zusammenarbeit. Über unseren Außendienst bekommen wir regelmäßig Rückmeldungen, dass SIHGA über die Medien des Zimmerer-Treffpunkts gesehen wird. Das Redaktions-Team unterstützt uns außerdem bei der Themenfindung und Gestaltung – ein Mehrwert für uns, der uns die Arbeit erleichtert.“',
      name: 'Jane-Beryl Simmer',
      title: 'Geschäftsführerin SIHGA',
      img: environment.publicFolder + 'assets/images/partner/compressed/JaneSimmer.png',
    },
    {
      text: '„Eine tolle Community, die der Treffpunkt da in den vergangenen Jahren zusammengeführt hat, und ein Gewinn fürs Handwerk, das uns als Hersteller von Kranen und Aufzügen für Dachdecker und Zimmerer selbstverständlich sehr am Herzen liegt. Wir unterstützen euch auf dem Weg in eine digitale und nachhaltige Zukunft sehr gern!“',
      name: 'Alexander Böcker',
      title: 'Geschäftsführer Böcker Maschinenwerke',
      img: environment.publicFolder + 'assets/images/partner/compressed/AlexanderBöcker.png',
    },
    {
      text: '„Entscheidend für den gemeinsamen Erfolg ist die Kommunikation und der Erfahrungsaustausch untereinander. Genau das bietet diese Plattform und trägt dazu bei, dass die gesamte Branche enger zusammenrückt. Darüber hinaus bietet sie Wissensvermittlung und dadurch einen  Mehrwert für alle Mitglieder. Deshalb unterstützen wir als Familienunternehmen in der 4. Generation den Zimmerer-Treffpunkt und freuen uns über diese tolle Partnerschaft.“',
      name: 'Tim Bauder',
      title: 'Geschäftsführer von Bauder',
      img: environment.publicFolder + 'assets/images/partner/compressed/TimBauder2.png',
    },
    {
      text: '„Der Zimmerer-Treff ist für uns ein sehr wichtiger Kommunikationskanal. Die Reichweite in der Branche ist sehr groß und wenn wir Fachbeiträge oder Produkt-Anzeigen veröffentlichen, wissen wir, dass damit eine hohe Durchdringung erzielt wird. Mir gefällt die zukunftsorientierte Aufstellung des Zimmerer-Treffpunkts und dass die Themen branchenbezogen und redaktionell sehr vielfältig sind.“',
      name: 'Michael Haller',
      title: 'Leiter Marketingservices bei Mafell',
      img: environment.publicFolder + 'assets/images/partner/compressed/MichaelHaller.png',
    },
    {
      text: '„Ein riesiges Plus beim Zimmerer-Treffpunkt ist, dass das Team nah an der Zielgruppe ist. Man merkt, dass sie selbst aus dem Handwerk kommen. So entstand ein toller Austausch zwischen uns über Inhalte, die echten Mehrwert für die Zielgruppe liefern.“',
      name: 'Jasmin Schäffler',
      title: 'Teamleiterin Online-Marketing bei FLEX',
      img: environment.publicFolder + 'assets/images/partner/compressed/JasminSchaeffler.png',
    },
  ];

  public getPartnerlogos(): Promise<Array<Partnerlogo>> {
    return new Promise((resolve, reject) => {
      if (this._partnerlogos.length) {
        resolve(this._partnerlogos);
        return;
      }

      // fetch
      this.RestService.get('partnerlogos')
        .then((response: Partnerlogo[]) => {
          // deserialize
          this.SerializationService.deserializeMany(Partnerlogo, response).then((partnerlogos: Partnerlogo[]) => {
            // resolve
            this._partnerlogos = partnerlogos;
            resolve(this._partnerlogos);
          });
        })
        .catch((err) => {
          this.SentryService.silentCaptureException(err);
          console.error(err);
          resolve([]);
        });
    });
  }

  private _partnerlogos: Array<Partnerlogo> = [];
}
